import React, { useEffect, lazy, Suspense } from "react";
import Insights from "../../components/Insights/Insights";
import MemberTeamDetail from "../Dashboard/Sponsorship/Sponsorship_Components/TeamDetail/MemberTeamDetail";
const Hero = lazy(() => import("../../components/hero/hero"));
const InvestIn = lazy(() => import("../../components/InvestIn/InvestIn"));
const Howitworks = lazy(() => import("../../components/HowitWorks/Howitworks"));
const ComparisonTable = lazy(() =>
  import("../../components/ComparisonBallers/ComparisonTable")
);
const MembershipBanner = lazy(() =>
  import("../../components/MembershipBannerBallers/MembershipBanner")
);
const MemberTestimonial = lazy(() =>
  import("../../components/Testimonials/MemberTestimonials")
);
const Dare = lazy(() => import("../../components/Dare/Dare"));
const Whyballer = lazy(() => import("../../components/WhyBaller/Whyballer"));
const Banner = lazy(() => import("../../components/banner/Banner"));
const Footer = lazy(() => import("../../components/Footer/Footer"));
const Home = () => {
  useEffect(() => {
    document.title = "Ballers | One membership. Unlimited Access.";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <Suspense fallback={null}>
        <Hero />
        <InvestIn />
        <Howitworks />
        {/* <Whysport /> */}
        <ComparisonTable />
        <MembershipBanner />
        <Dare />
        {/* <Whyballer /> */}
        <MemberTestimonial />
        {/* <Insights /> */}
        {/* <Isballerforyou /> */}
        <Banner />
        <Footer />
      </Suspense>
    </div>
  );
};

export default Home;
